// extracted by mini-css-extract-plugin
export default {"root":"TabBar_root__J1yoN","indicator":"TabBar_indicator__ez8xM"};